let userType = [
    {
        id: "1",
        name: "会员用户"
    }, {
        id: "2",
        name: "普通用户"
    }
]
let memberStatus = [
    {
        id: "1",
        name: "未签单"
    }, {
        id: "2",
        name: "已签单"
    }, {
        id: "3",
        name: "已离院"
    }, {
        id: "4",
        name: "二次意向"
    }, {
        id: "5",
        name: "二次签单"
    }
]

let insert_way = [
    {
        id: "6",
        name: "雨花石录入"
    },
    {
        id: "4",
        name: "手机端录入"
    },
    {
        id: "3",
        name: "web端录入"
    },
    {
        id: "8",
        name: "会员部商城平台录入"
    },
    {
        id: "10",
        name: "营销中心录入"
    },
    {
        id: "11",
        name: "推广页面录入"
    }
]
let add_member_insert_way = [
    {
        id: "1",
        name: "CRM批量导入"
    },
    {
        id: "2",
        name: "PAD端录入"
    },
    {
        id: "3",
        name: "WEB端"
    }
]
let follow_status = [
  
    {
        id: "1",
        name: "未回访"
    },
    {
        id: "2",
        name: "当天需回访"
    },
    {
        id: "3",
        name: "逾期未回访"
    },
    {
        id: "6",
        name: "放弃跟进"
    },
    {
        id: "5",
        name: "成功转化"
    },
    {
        id: "4",
        name: "正常状态"
    }
]
let come_status = [
    {
        id: "1",
        name: "待确定"
    },
    
    {
        id: "3",
        name: "有需求"
    },
    {
        id: "2",
        name: "已到店"
    },
]
let family_relation = [
    {
        id: "1",
        name: "夫妻"
    },
    {
        id: "2",
        name: "女方家属"
    },
    {
        id: "3",
        name: "男方家属"
    },
    {
        id: "4",
        name: "其他"
    }
]
let industry = [
    {
        id: "教育",
        name: "教育"
    },
    {
        id: "医药卫生",
        name: "医药卫生"
    },
    {
        id: "IT通讯",
        name: "IT通讯"
    },
    {
        id: "金融保险",
        name: "金融保险"
    },
    {
        id: "社会公共服务",
        name: "社会公共服务"
    },
    {
        id: "建筑房地产",
        name: "建筑房地产"
    },
    {
        id: "住宿旅游",
        name: "住宿旅游"
    },
    {
        id: "其他",
        name: "其他"
    },
]

const chankang_types = [
    {
        id: "1",
        name: "普客"
    },
    {
        id: "2",
        name: "新客"
    },
    {
        id: "3",
        name: "老客"
    },
    {
        id: "4",
        name: "外客"
    }

]
export default {
    userType,
    insert_way,
    add_member_insert_way,
    follow_status,
    come_status,
    family_relation,
    industry,
    chankang_types,
    memberStatus
}



// WEBPACK FOOTER //
// ./src/util/baseData.js